import { Injectable } from '@angular/core';
import { BeneficiaryGroup } from '@shared/beneficiary/beneficiary-group';
import { FundingApi } from '@shared/funding/funding-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CandidateGroupForMoneybarResolver {
  constructor(private fundingApi: FundingApi) {}

  resolve(): Observable<BeneficiaryGroup[]> {
    return this.fundingApi.getCanidateGroupsForMoneybar();
  }
}
